import React from "react";
import { ChevronLeftIcon, ChevronRightIcon, XMarkIcon, MapPinIcon, ClipboardDocumentCheckIcon } from "@heroicons/react/24/outline";
import { Dialog } from "@headlessui/react";

function ModalDayHeader({
    title,
    subtitle,
    Icon,
    onClose,
    onPrevious,
    onNext,
    previousDisabled = false,
    nextDisabled = false,
    closeDisabled = false,
    mode,
    onModeChange,
    showWorkingAreaMode = false,
    showJustificationMode = false,
    isSenzaCalendario,
}) {
    return (
        <div className="rounded-t-xl border-b border-indigo-100 bg-indigo-100 px-4 py-3 sm:px-6">
            <div className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-3">
                {/* PRECEDENTE */}
                <button
                    type="button"
                    onClick={onPrevious}
                    disabled={previousDisabled}
                    className="
                        inline-flex h-8 shrink-0 items-center gap-1.5
                        rounded-md border border-indigo-200 bg-white
                        px-2.5 text-xs font-semibold text-indigo-700
                        shadow-sm transition-colors
                        hover:border-indigo-300 hover:bg-indigo-50
                        disabled:cursor-not-allowed disabled:opacity-40
                        sm:px-3
                    "
                >
                    <ChevronLeftIcon className="h-4 w-4 shrink-0" />

                    <span className="hidden sm:inline">
                        Precedente
                    </span>
                </button>

                {/* TITOLO CENTRALE */}
                <div className="flex min-w-0 flex-col items-center justify-center">
                    <div className="flex min-w-0 items-center justify-center gap-1.5">
                        {Icon && (
                            <Icon className="h-4 w-4 shrink-0 text-indigo-700" />
                        )}

                        <Dialog.Title className="truncate text-sm font-semibold uppercase text-indigo-800">
                            {title}
                        </Dialog.Title>
                    </div>

                    {subtitle && (
                        <p className="mt-0.5 max-w-full truncate text-xs text-gray-500">
                            {subtitle}
                        </p>
                    )}
                    {!isSenzaCalendario && (
                        <>
                            {(showWorkingAreaMode || showJustificationMode) && (
                                <div className="mt-2 inline-flex overflow-hidden rounded-md border border-indigo-200 bg-white shadow-sm">

                                    {showWorkingAreaMode && (
                                        <button
                                            type="button"
                                            onClick={() => onModeChange?.("working-area")}
                                            className={`inline-flex h-7 items-center gap-1.5 px-2.5 text-[10px] font-semibold uppercase transition-colors ${
                                                mode === "working-area"
                                                    ? "bg-indigo-600 text-white"
                                                    : "bg-white text-indigo-700 hover:bg-indigo-50"
                                            }`}
                                        >
                                            <MapPinIcon className="h-3.5 w-3.5 shrink-0" />
                                            Area di lavoro
                                        </button>
                                    )}

                                    {showJustificationMode && (
                                        <button
                                            type="button"
                                            onClick={() => onModeChange?.("justification")}
                                            className={`inline-flex h-7 items-center gap-1.5 border-l border-indigo-200 px-2.5 text-[10px] font-semibold uppercase transition-colors ${
                                                mode === "justification"
                                                    ? "bg-indigo-600 text-white"
                                                    : "bg-white text-indigo-700 hover:bg-indigo-50"
                                            }`}
                                        >
                                            <ClipboardDocumentCheckIcon className="h-3.5 w-3.5 shrink-0" />
                                            Giustificativi
                                        </button>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>

                {/* SUCCESSIVO + CHIUDI */}
                <div className="flex shrink-0 items-center gap-2">
                    <button
                        type="button"
                        onClick={onNext}
                        disabled={nextDisabled}
                        className="
                            inline-flex h-8 shrink-0 items-center gap-1.5
                            rounded-md border border-indigo-200 bg-white
                            px-2.5 text-xs font-semibold text-indigo-700
                            shadow-sm transition-colors
                            hover:border-indigo-300 hover:bg-indigo-50
                            disabled:cursor-not-allowed disabled:opacity-40
                            sm:px-3
                        "
                    >
                        <span className="hidden sm:inline">
                            Successivo
                        </span>

                        <ChevronRightIcon className="h-4 w-4 shrink-0" />
                    </button>

                    <button
                        type="button"
                        onClick={onClose}
                        disabled={closeDisabled}
                        aria-label="Chiudi"
                        className="
                            flex h-8 w-9 shrink-0 items-center justify-center
                            rounded-md border border-gray-300 bg-white
                            text-gray-500 shadow-sm transition-colors
                            hover:border-gray-400 hover:bg-gray-50 hover:text-gray-700
                            disabled:cursor-not-allowed disabled:opacity-40
                            focus:outline-none
                            focus-visible:ring-2
                            focus-visible:ring-indigo-500
                            focus-visible:ring-offset-2
                        "
                    >
                        <XMarkIcon className="h-5 w-5 shrink-0" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalDayHeader;